import type { CustomTheme } from './types';

/**
 * Default styled-components theme for the standalone Knowledge Hub
 * viewers (PdfDocumentViewer, ChapteredVideoPlayer). Aligned with the
 * theme-v2 accent. Consumers can override per-publication brand.
 *
 * TODO(MED-XXXX): derive these from the theme-v2 tokens in @libertify/ui
 * instead of hardcoding, so the accent stays in sync in one place.
 */
export const KNOWLEDGE_HUB_THEME: CustomTheme = {
  colors: {
    primary: '#14B8A6', // accent.base
    ctaTextColor: '#FFFFFF',
    secondary: '#6B7280', // text.secondary
    highlight: 'rgba(20, 184, 166, 0.20)', // accent.base @ 20%
  },
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};
